import React from "react";

// TIP-491 (MV Stage 3) — per-company verification entry on the dashboard.
// Verification is a FREE, member-only request:
//   - verified  → static "Verified" badge (nothing to do)
//   - member    → "Request verification" button (or an "in review" state once
//                 requested). Approval by an admin is what grants Verified.
//   - claimed / listed (non-member) → upsell, never a request.
export const RequestVerificationAction = ({
  profileStatus,
  requested = false,
  submitting = false,
  onRequest = () => {},
  onUpsell = () => {},
}) => {
  if (profileStatus === "verified") {
    return (
      <span className="text-success text-f12 font-semibold">✓ Verified</span>
    );
  }

  if (profileStatus === "member") {
    if (requested) {
      return (
        <span className="text-primary text-f12 font-semibold">
          Verification requested — in review
        </span>
      );
    }
    return (
      <button
        type="button"
        onClick={onRequest}
        disabled={submitting}
        className="bg-primary text-white text-f12 font-semibold rounded-md px-3 py-1 disabled:opacity-50"
      >
        {submitting ? "Requesting…" : "Request verification"}
      </button>
    );
  }

  // claimed / listed / unknown → not a member yet. Upsell, never a request.
  return (
    <button
      type="button"
      onClick={onUpsell}
      className="text-primary text-f12 font-semibold underline"
    >
      Become a member to get verified
    </button>
  );
};

export default RequestVerificationAction;
